import NumberInput from '~/components/widgets/NumberInput/NumberInput';
import EditorLabel from '../EditorLabel/EditorLabel';
import './EditorNumber.css';

export interface EditorNumberProps {
  name: string;
  value: number;
  onChange: (val: number) => void;
  label: string;
  max: number;
  min: number;
  step?: number;
  unit?: string;
  disabled?: boolean;
  onBlur?: () => void;
}

export default function EditorNumber({
  name,
  value,
  onChange,
  label,
  max,
  min,
  step,
  unit,
  disabled,
  onBlur
}: EditorNumberProps) {
  return (
    <div className="EditorNumber">
      <EditorLabel label={label} htmlFor={name} />
      <NumberInput
        className="EditorNumber-input"
        name={name}
        value={value}
        min={min}
        max={max}
        step={step}
        unit={unit}
        disabled={disabled}
        onBlur={onBlur}
        onChange={onChange}
      />
    </div>
  );
}
